import { useState } from "react";
import '../src/Login.css';
import logo from "./assets/logoWithText.avif"
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate(); // ✅ FIX
  const handleLogin = async () => {
    try {
      const res = await fetch(
        "https://web.theplatformapi.com/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mobile, password }),
        }
      );

      const data = await res.json();
      console.log(data);

      /* ✅ SUCCESS CHECK (adjust key if backend differs) */
      if (res.ok && data?.success) {
        // Optional: store token or user data
        localStorage.setItem("token", data.token);

        // ✅ Redirect to Home
        navigate("/home");
      } else {
        alert(data?.message || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Something went wrong");
    }
  }

  return (
    <div className="auth-page">
      <div className= "auth-card">
        <div className="auth-logo">
          {/* <img src="../assets/logo.png" alt="TrediXO" /> */}
          <img src={logo} alt="TrediXO" />

        </div>

        <div className="auth-title">Welcome,</div>
        <div className="auth-subtitle">Login to Your Account.</div>

        <input
          className="auth-input"
          placeholder="Enter Mobile number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
        />

        <input
          className="auth-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button className="auth-btn" onClick={handleLogin}>
          Login
        </button>

        <div className="auth-footer">
          Don’t have an account? <span>Create A Live Account</span>
        </div>
      </div>
    </div>
  );
}
